import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function AdminShell({ children }) {
  const loc = useLocation();

  const Item = ({ to, label }) => (
    <Link
      to={to}
      className={`block px-4 py-2 rounded-lg text-sm ${
        loc.pathname.startsWith(to)
          ? "bg-white/10 text-white"
          : "text-white/50 hover:text-white"
      }`}
    >
      {label}
    </Link>
  );

  return (
    <div className="flex min-h-screen bg-[#07090d] text-white">
      {/* SIDEBAR */}
      <div className="w-64 border-r border-white/10 p-4 space-y-4">
        <div className="text-lg font-semibold mb-6">Admin</div>

        <Item to="/admin/dashboard" label="Dashboard" />
        <Item to="/admin/users" label="Users" />
        <Item to="/admin/moderation" label="Moderation" />
        <Item to="/admin/metrics" label="Metrics" />
        <Item to="/admin/heatmap" label="Heatmap" />
        <Item to="/admin/analytics" label="Analytics" />
        <Item to="/admin/messages" label="Messages" />
      </div>

      {/* CONTENT */}
      <div className="flex-1">{children}</div>
    </div>
  );
}
